import { css } from 'styled-components';
import { forDesktop } from '@westwing/ui-kit/breakPoints';
// we need to import the variables direclty because this is outside of the ThemeProvider
import font from './fonts';

// TODO: kill this and use typography from ui-kit
const text = {
    text: {
        fontFamily: `${font.fontBrandonRegular}`,
        fontSize: '14px',
        letterspacing: '0.25px  ',
        lineHeight: '1.40',
    },
    header1: {
        fontFamily: `${font.fontChronicleRoman}`,
        fontSize: '7.33em',
        letterspacing: '0.0075',
        lineHeight: '1.40',
    },
    header2: {
        fontFamily: `${font.fontChronicleRoman}`,
        fontSize: '2em',
        lineHeight: '1.39',
        letterspacing: '0.15',
    },
    header3: {
        fontFamily: `${font.fontChronicleRoman}`,
        fontSize: '3.66em',
        letterspacing: '0.0075',
        lineHeight: '1.30',
    },
    header4: {
        fontFamily: `${font.fontChronicleRoman}`,
        fontSize: '2.59em',
        letterspacing: '0.0075',
        lineHeight: '1.50',
    },
    header5: {
        fontFamily: `${font.fontChronicleRoman}`,
        fontSize: '1.83em',
        letterspacing: '0.0075',
        lineHeight: '1.50',
    },
    header6: {
        fontFamily: `${font.fontChronicleRoman}`,
        fontSize: '1.58em',
        letterspacing: '0.2px',
        lineHeight: '1.41',
    },
    subtitle1: {
        fontFamily: `${font.fontBrandonRegular}`,
        fontSize: '1.22em',
        letterspacing: '0.0075',
        lineHeight: '1.50',
    },
    button: {
        fontFamily: `${font.fontBrandonRegular}`,
        fontSize: '1.02em',
        letterspacing: '0.0175em',
        lineHeight: '1.50',
    },
    body1: {
        fontFamily: `${font.fontBrandonRegular}`,
        fontSize: '1.22em',
        letterspacing: '0.00025em',
        lineHeight: '1.50',
    },
    body2: {
        fontFamily: `${font.fontBrandonRegular}`,
        fontSize: '1.07em',
        letterspacing: '-0.3px',
        lineHeight: '1.50',
    },
    body3: {
        fontFamily: `${font.fontBrandonRegular}`,
        fontSize: '14px',
        letterspacing: '0.25px',
        lineHeight: '21px',
    },
    caption: {
        fontFamily: `${font.fontBrandonRegular}`,
        fontSize: '0.86em',
        letterspacing: '0.02em',
        lineHeight: '1.25',
    },
    caption3: {
        fontFamily: `${font.fontBrandonRegular}`,
        fontSize: '0.71422em',
        letterspacing: '0.01em',
        lineHeight: '1.25',
    },
    overline: {
        fontFamily: `${font.fontBrandonRegular}`,
        fontSize: '0.76em',
        letterspacing: '0.015em',
        lineHeight: '1.50',
    },
    badge: {
        fontFamily: `${font.fontBrandonRegular}`,
        fontSize: '1.285em',
        letterspacing: '0.007em',
        lineHeight: 'normal',
    },

    badge2: {
        fontFamily: `${font.fontBrandonRegular}`,
        fontSize: '0.571em',
        letterspacing: '0.017em',
        lineHeight: 'normal',
    },
};

export const desktopText = {
    subtitle1: {
        fontSize: '1.57em',
        lineHeight: '2.00',
    },
    button: {
        lineHeight: '1.00',
    },
};

export default text;

type FontKey = keyof typeof text | keyof typeof desktopText;

const desktopTextStyle = (key: FontKey) => css`
    ${desktopText[key]
        ? forDesktop`
            ${desktopText[key].fontSize ? `font-size: ${desktopText[key].fontSize}` : ''};
            ${desktopText[key].letterspacing ? `letter-spacing: ${desktopText[key].letterspacing}` : ''};
            ${desktopText[key].lineHeight ? `line-height: ${desktopText[key].lineHeight}` : ''};
        `
        : ''}
`;

export const textStyle = (key: FontKey) => css`
    font-family: ${({ theme }) => theme[key].fontFamily};
    font-size: ${({ theme }) => theme[key].fontSize};
    line-height: ${({ theme }) => theme[key].lineHeight};
    letter-spacing: ${({ theme }) => theme[key].letterspacing};
    ${desktopTextStyle(key)}
`;
